module.exports = __webpack_public_path__ + "static/media/ldskjv.6baf027c.jpg";